import { Button } from "@/components/ui/button";
import {
  DialogFooter,
  // DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import { CountryInput } from "@/components/form-input";
import { GenericType } from "@/types";

type UserFormType = {
  formData: GenericType;
  onFormSubmit: (prop: boolean) => Promise<void>;
};
export const ReactForm = ({ formData, onFormSubmit }: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onFormSubmit,
  });

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="divide-solid divide-y   px-6 ">
            <FormField
              control={form.control}
              name="username"
              disabled={true}
              render={({ field }) => (
                <FormItem className="flex p-[12px_0px_23px_0px]">
                  <div className="w-[200px] pt-4">
                    <FormLabel>Username</FormLabel>
                  </div>
                  <FormControl>
                    <Input placeholder="Username" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="country"
              render={({ field }) => (
                <FormItem className="flex p-[12px_0px_23px_0px]">
                  <div className="w-[200px] pt-4">
                    <FormLabel>Country</FormLabel>
                  </div>
                  <FormControl>
                    <CountryInput
                      placeholder="Country"
                      value={field.value}
                      onChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem className="flex p-[12px_0px_23px_0px]">
                  <div className="w-[200px] pt-4">
                    <FormLabel>Email</FormLabel>
                  </div>
                  <FormControl>
                    <Input placeholder="Email" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="phone"
              render={({ field }) => (
                <FormItem className="flex p-[12px_0px_23px_0px]">
                  <div className="w-[200px] pt-4">
                    <FormLabel>Phone</FormLabel>
                  </div>
                  <FormControl>
                    <Input placeholder="Phone" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="company_name"
              disabled={true}
              render={({ field }) => (
                <FormItem className="flex p-[12px_0px_23px_0px]">
                  <div className="w-[200px] pt-4">
                    <FormLabel>Company name</FormLabel>
                  </div>
                  <FormControl>
                    <Input
                      placeholder="Company name"
                      {...field}
                      disabled={true}
                    />
                  </FormControl>

                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <hr className="mt-5" />
          <DialogFooter className="p-6 flex !justify-start">
            <Button
              type="submit"
              className="w-[150px]"
              disabled={form.formState.isSubmitting}
            >
              {form.formState.isSubmitting ? (
                <IconRender
                  name="LoaderCircle"
                  className="w-5 animate-spin text-white zoom-in-150"
                />
              ) : (
                "Save"
              )}
            </Button>
          </DialogFooter>
        </form>
      </Form>
    </>
  );
};
